import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import classNames from "classnames";
import { CircleLoader } from "../../components/CircleLoader";
import { LinkBehaviour } from "../../components/LinkBehaviour";
import ArrowRightIcon from "../../icons/arrow-right.svg";
import ChevronIcon from "../../icons/chevron.svg";
import styles from "./Button.module.scss";
const ButtonContent = ({ children, variant, color, }) => {
    if (variant === "redirect" && color === "primary") {
        return (_jsxs(_Fragment, { children: [_jsx("div", { "data-testid": "buttonChevronIcon", className: styles.chevronIconWrapper, children: _jsx(ChevronIcon, { className: styles.chevronIcon }) }), _jsx("span", { className: styles.label, children: children })] }));
    }
    if (variant === "redirect" && color === "secondary") {
        return (_jsxs(_Fragment, { children: [_jsx("span", { className: styles.label, children: children }), _jsx(ArrowRightIcon, { "data-testid": "buttonArrowRightIcon", className: styles.arrowIcon })] }));
    }
    return children;
};
const themeClass = {
    dark: "dark-theme",
    light: "light-theme",
};
const loaderWidth = {
    small: 22,
    medium: 30,
    large: 30,
};
export const Button = forwardRef(({ children, isPending, size = "medium", ...props }, ref) => {
    const loader = isPending ? (_jsx(CircleLoader, { className: styles.buttonLoader, dataTestId: "buttonLoader", width: loaderWidth[size] })) : null;
    if ("href" in props) {
        const { variant = "cta", color = "primary", disabled, nativeBehaviour, className, ...htmlAnchorAttributes } = props;
        return (_jsx(LinkBehaviour, { className: classNames(styles[variant], styles[size], styles[color], themeClass[props.theme], {
                [styles.disabled]: disabled || isPending,
            }, {
                [styles.pending]: isPending,
            }, className), tabIndex: disabled ? -1 : 0, nativeBehaviour: nativeBehaviour, ...htmlAnchorAttributes, children: _jsxs(ButtonContent, { color: color, variant: variant, children: [_jsx("span", { className: styles.content, children: children }), loader] }) }));
    }
    const { variant = "cta", color = "primary", type = "button", disabled, className, ...htmlButtonAttributes } = props;
    return (_jsx("button", { ref: ref, className: classNames(styles[variant], styles[size], styles[color], themeClass[props.theme], {
            [styles.pending]: isPending,
        }, className), disabled: disabled || isPending, type: type, ...htmlButtonAttributes, children: _jsxs(ButtonContent, { color: color, variant: variant, children: [_jsx("span", { className: styles.content, children: children }), loader] }) }));
});
//# sourceMappingURL=Button.js.map